import React from 'react';
function base64ToFile(base64,filename,mime){
    let bin = atob(base64.replace(/^.*,/, ''));
    let buffer = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i);
    }
    return new File([buffer.buffer], filename, {type: mime});
}
export function load(fileList,file,i,callback){
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function(){
        let img = document.createElement('img');
        img.src = reader.result
        img.onload = function(){

            // bmpの場合はファイルサイズが大きいのでPNGに圧縮する
            if(file.name.match(/\.(bmp|dib|rle)$/) !== null){
                console.log("bmpをpngに圧縮しました。",file.name)
                let canvas = document.createElement("canvas")
                canvas.width = img.width
                canvas.height = img.height
                let ctx = canvas.getContext("2d")
                ctx.drawImage(img,0,0)
                let base64 = canvas.toDataURL("image/png")
                fileList.filter((f,j) => j === i).map(d => d.file = base64ToFile(base64,file.name))
            }

            // 長いほうを縮める
            let w = 0
            let h = 0
            if(img.width > img.height){
                w = 300
                h = 300 / img.width * img.height
            } else {
                w = 300 / img.height * img.width
                h = 300
            }
            let w2 = 0
            let h2 = 0
            if(img.width > img.height){
                w2 = 768
                h2 = 768 / img.width * img.height
            } else {
                w2 = 768 / img.height * img.width
                h2 = 768
            }
            callback(resizeImg(img,w,h),resizeImg(img,w2,h2),reader.result)
        }
        img.onerror = function(){
            callback(false)
        }
    }
}
export function loadImage(files,func,fixed){
    let reader = new FileReader()
    reader.readAsDataURL(files[0])
    reader.onload = function(){
        let img = document.createElement('img');
        img.src = reader.result
        img.onload = function(){
            if(fixed){
                func(resizeImg(img,300,300))
            } else {
                let w = 300
                let h = img.naturalHeight * (300 / img.naturalWidth)
                func(resizeImg(img,w,h))
            }
        }
        img.onerror = function(){
            func("")
        }
    }
}
export function loadImageBig(files,func,fixed){
    let reader = new FileReader()
    reader.readAsDataURL(files[0])
    reader.onload = function(){
        let img = document.createElement('img');
        img.src = reader.result
        img.onload = function(){
            if(fixed){
                func(resizeImg(img,300,300))
            } else {
                let targetWidth = img.width
                if(img.width > 2560){
                    targetWidth = 2560
                }
                let w = targetWidth
                let h = img.naturalHeight * (targetWidth / img.naturalWidth)
                func(resizeImg(img,w,h))
            }
        }
        img.onerror = function(){
            func("")
        }
    }
}
// 2:1のサムネイルを生成する
export function loadImageOutsideThumbnail(files,func){
    let reader = new FileReader()
    reader.readAsDataURL(files[0])
    reader.onload = function(){
        let img = document.createElement('img');
        img.src = reader.result
        img.onload = function(){
            let w = 1600
            let h = 800
            func(resizeImgToPng(img,w,h))
        }
        img.onerror = function(){
            func("")
        }
    }
}
export function resizeImg(imgData,w,h) {
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(imgData, 0, 0, w, h);
    return canvas.toDataURL('image/jpeg',0.9)
}
export function resizeImgToPng(imgData,w,h) {
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(imgData, 0, 0, w, h);
    return canvas.toDataURL('image/png',0.9)
}
export function imgToDataURL(img) {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL('image/png')
}
export function videoLoad(fileList,file,i,callback,loaded){
    let reader = new FileReader()
    reader.readAsArrayBuffer(file)
    reader.onload = function(){
        var blob = new Blob([reader.result], {type: file.type})
        var url = URL.createObjectURL(blob)
        var video = document.createElement('video')
        var thumbnailFrame = 0; // サムネイル取得秒指定
        var retryCount = 10; // サムネイル生成失敗許容回数
        var currentCount = 0;
        // timeupdateイベントで動画の再生を検知しています
        var timeupdate = function() {
            console.log("tiemupdate")
            if (snapImage()) {
                video.removeEventListener('timeupdate', timeupdate)
                video.pause()
            } else if (currentCount == retryCount) {
            // サムネイル生成失敗
                console.log("make thumbnail failed")
                video.removeEventListener('timeupdate', timeupdate)
                video.pause()
            }
        }
        var snapImage = function() {
            console.log(video.currentTime)
            // 3.再生後、さらに新規生成した<canvas>要素で描画
            var canvas = document.createElement('canvas')
            
            console.log(video)
            canvas.width = video.videoWidth
            canvas.height = video.videoHeight
            canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height)
            // 4.描画後にtoDataURL()関数を利用して画像blobを取得、適宜<img>要素へ適応
            var img = canvas.toDataURL("image/png")
            var success = img.length > 100
            if (success) {
                var imgElm = document.createElement('img')
                imgElm.src = img
                setTimeout(() => { // Safari対策
                    URL.revokeObjectURL(url)
                }, 2000)

                // 長いほうを縮める
                let w = 0
                let h = 0
                if(canvas.width > canvas.height){
                    w = 300
                    h = 300 / canvas.width * canvas.height
                } else {
                    w = 300 / canvas.height * canvas.width
                    h = 300
                }
                let w2 = 0
                let h2 = 0
                if(canvas.width > canvas.height){
                    w2 = 768
                    h2 = 768 / canvas.width * canvas.height
                } else {
                    w2 = 768 / canvas.height * canvas.width
                    h2 = 768
                }
                callback(resizeImg(imgElm,w,h),resizeImg(imgElm,w2,h2),img)
                loaded(true)
                //console.log(imgElm,w,h,canvas.width,canvas.height)
                //document.querySelector("#select-img").src = img
            } else {
                currentCount+=1;
            }
            return success;
        }
        video.addEventListener('canplay', function() {
            if (video.duration > thumbnailFrame) {
                video.currentTime = thumbnailFrame
            } else {
                video.currentTime = video.duration / 2
            }
        })
        video.addEventListener('timeupdate', timeupdate)
        video.preload = 'meta'
        video.src = url
        // Safari / IE11
        video.muted = true
        video.playsInline = true
        console.log("play")
        video.play()
        return 
        return
        let img = document.createElement('img');
        img.src = reader.result
        img.onload = function(){

            // bmpの場合はファイルサイズが大きいのでPNGに圧縮する
            if(file.name.match(/\.(bmp|dib|rle)$/) !== null){
                console.log("bmpをpngに圧縮しました。",file.name)
                let canvas = document.createElement("canvas")
                canvas.width = img.width
                canvas.height = img.height
                let ctx = canvas.getContext("2d")
                ctx.drawImage(img,0,0)
                let base64 = canvas.toDataURL("image/png")
                fileList.filter((f,j) => j === i).map(d => d.file = base64ToFile(base64,file.name))
            }

            // 長いほうを縮める
            let w = 0
            let h = 0
            if(img.width > img.height){
                w = 300
                h = 300 / img.width * img.height
            } else {
                w = 300 / img.height * img.width
                h = 300
            }
            let w2 = 0
            let h2 = 0
            if(img.width > img.height){
                w2 = 768
                h2 = 768 / img.width * img.height
            } else {
                w2 = 768 / img.height * img.width
                h2 = 768
            }
            callback(resizeImg(img,w,h),resizeImg(img,w2,h2),reader.result)
        }
        img.onerror = function(){
            callback(false)
        }
    }
}